// extracted by mini-css-extract-plugin
export default {"desktop":"NavigationMenu_desktop__p4TcH","mobile":"NavigationMenu_mobile__PRHPM"};